module.exports = __webpack_public_path__ + "static/media/taiko-logo.d39e3ecb.png";